import styles from "./Planning.module.scss";
import React, { useMemo, useState } from "react";
import clsx from "clsx";
import { useQuery } from "@tanstack/react-query";
import { apiGetContext } from "../../api/ApiApp";
import SiteEventEditor from "../sites/SiteEventEditor";
import { MODE_CREATE, MODE_EDIT } from "../../codes";
import useFormat from "../../util/useFormat";
import Button from "../../common/Button";
import { DATE_FORMAT, MONTH_FORMAT, siteDayDetails } from "./planningData";
import { usePlanningMonths } from "./usePlanningData";
import SiteDayDetails from "./SiteDayDetails";

const PlanningDaySummary = ({ daySummary, setDaySummary, onEventSubmitted }) => {
  const { formatDate } = useFormat();

  const [eventEditor, setEventEditor] = useState({ show: false, event: {}, mode: MODE_CREATE, site: { id: null } });

  const site = daySummary.site;
  const dayKey = daySummary.date.format(DATE_FORMAT);

  // For a site: its workers and prestation notes, from the same monthly data as the plannings
  const { prestations } = usePlanningMonths(site ? [daySummary.date.format(MONTH_FORMAT)] : [], true);
  const contextQuery = useQuery(apiGetContext());

  const details = useMemo(() => {
    if (!site) {
      return null;
    }

    const workersById = new Map((contextQuery.data?.workers || []).map(worker => [worker.id, worker]));
    const sitePrestations = prestations.filter(
      prestation => prestation.siteId === site.id && prestation.date === dayKey
    );

    return siteDayDetails(sitePrestations, workersById);
  }, [site, dayKey, prestations, contextQuery.data]);

  return <>
    <div className={clsx(styles.daySummary, daySummary.shown ? styles.shown : null)}>
      <div className={styles.header}>
        <div className={styles.daySummaryTitle}>
          {formatDate(daySummary.date)}
        </div>

        <Button variant="secondary" onClick={() => setDaySummary(prev => ({ ...prev, shown: false }))}>Fermer</Button>
      </div>

      {daySummary.site && <div className={styles.siteName}
                               style={{
                                 backgroundColor: daySummary.site.color.split("|")[0],
                                 color: daySummary.site.color.split("|")[1]
                               }}>
        {daySummary.site.name}
      </div>}

      {details && <SiteDayDetails workers={details.workers} notes={details.notes} full/>}

      <div className={styles.daySummaryEvents}>
        {daySummary.events
          .filter(event => (daySummary.site && daySummary.site.id === event.siteId)
            || (!daySummary.site && !event.siteId))
          .map(event => {
            return <div key={event.id} className={styles.event} onClick={() => setEventEditor(prev => ({
              show: true,
              site: daySummary.site || {},
              mode: MODE_EDIT,
              event
            }))}>
              <div className={styles.title}>{event.name}</div>
              <div className={styles.description} dangerouslySetInnerHTML={{ __html: (event.description) }} />
            </div>;
          })}
      </div>
    </div>

    <SiteEventEditor
      show={eventEditor.show}
      hide={() => setEventEditor(prev => ({ ...prev, show: false }))}
      mode={eventEditor.mode}
      site={eventEditor.site}
      event={eventEditor.event}
      onSubmit={onEventSubmitted}
    />
  </>;
};

export default PlanningDaySummary;